var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentationNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4551_26863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3H5.25C4.85218 3 4.47064 3.15804 4.18934 3.43934C3.90804 3.72064 3.75 4.10218 3.75 4.5C3.75 4.89782 3.90804 5.27936 4.18934 5.56066C4.47064 5.84196 4.85218 6 5.25 6H15.75V15.75C15.75 15.9489 15.671 16.1397 15.5303 16.2803C15.3897 16.421 15.1989 16.5 15 16.5H5.25C4.45435 16.5 3.69129 16.1839 3.12868 15.6213C2.56607 15.0587 2.25 14.2956 2.25 13.5V4.5C2.25 3.70435 2.56607 2.94129 3.12868 2.37868C3.69129 1.81607 4.45435 1.5 5.25 1.5H15C15.1989 1.5 15.3897 1.57902 15.5303 1.71967C15.671 1.86032 15.75 2.05109 15.75 2.25V3ZM3.75 13.5C3.75 13.8978 3.90804 14.2794 4.18934 14.5607C4.47064 14.842 4.85218 15 5.25 15H14.25V7.5H5.25C4.72337 7.50084 4.20588 7.36241 3.75 7.09875V13.5ZM15 5.25H5.25C5.05109 5.25 4.86032 5.17098 4.71967 5.03033C4.57902 4.88968 4.5 4.69891 4.5 4.5C4.5 4.30109 4.57902 4.11032 4.71967 3.96967C4.86032 3.82902 5.05109 3.75 5.25 3.75H15V5.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4551_26863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentationNav);
export default __webpack_public_path__ + "static/media/documentation-nav.c05832253a05138374a5c9c48c3505dd.svg";
export { ForwardRef as ReactComponent };